import { useCallback, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { MicButtonState } from './types';
import type { RemoteTelephone } from '@tier4/webauto-media-client';

export const useRemoteCallButton = () => {
  const { t } = useTranslation();
  const [state, setState] = useState<MicButtonState>('init');
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const usingTelephoneIdRef = useRef<string>();
  const [usingTelephone, setUsingTelephone] = useState<RemoteTelephone>();

  const handleChangeState = useCallback((telephone: RemoteTelephone) => {
    console.log(telephone, usingTelephoneIdRef.current);
    if (usingTelephoneIdRef.current !== telephone.id) return;
    if (telephone.state === 'calling') {
      setState('calling');
      setUsingTelephone(telephone);
    }
    if (telephone.state === 'talking') {
      setState('talking');
      setUsingTelephone(telephone);
    }
    if (telephone.state === 'online') {
      setState('init');
      usingTelephoneIdRef.current = undefined;
      setUsingTelephone(undefined);
    }
  }, []);

  const handleClickButton = useCallback(
    async (e: React.MouseEvent<HTMLButtonElement>) => {
      if (state === 'init') {
        setAnchorEl(e.currentTarget);
        return;
      }
      if (state === 'calling' || state === 'talking') {
        await usingTelephone?.hangup();
        return;
      }
    },
    [state, usingTelephone],
  );

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleClickMenuItem = useCallback(
    async (telephone: RemoteTelephone) => {
      if (!telephone || telephone.state !== 'online') return;
      usingTelephoneIdRef.current = telephone.id;
      setAnchorEl(null);
      await telephone.call();
    },
    [],
  );

  return {
    t,
    state,
    anchorEl,
    usingTelephone,
    handleClickButton,
    handleCloseMenu,
    handleClickMenuItem,
    handleChangeState,
  };
};
